/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupDto } from './GroupDto';
import {
    GroupDtoFromJSON,
    GroupDtoFromJSONTyped,
    GroupDtoToJSON,
    GroupDtoToJSONTyped,
} from './GroupDto';
import type { ControlDto } from './ControlDto';
import {
    ControlDtoFromJSON,
    ControlDtoFromJSONTyped,
    ControlDtoToJSON,
    ControlDtoToJSONTyped,
} from './ControlDto';

/**
 * 
 * @export
 * @interface CategoryWithControlsDto
 */
export interface CategoryWithControlsDto {
    /**
     * 
     * @type {GroupDto}
     * @memberof CategoryWithControlsDto
     */
    category?: GroupDto;
    /**
     * 
     * @type {Array<ControlDto>}
     * @memberof CategoryWithControlsDto
     */
    controls?: Array<ControlDto>;
}

/**
 * Check if a given object implements the CategoryWithControlsDto interface.
 */
export function instanceOfCategoryWithControlsDto(value: object): value is CategoryWithControlsDto {
    return true;
}

export function CategoryWithControlsDtoFromJSON(json: any): CategoryWithControlsDto {
    return CategoryWithControlsDtoFromJSONTyped(json, false);
}

export function CategoryWithControlsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryWithControlsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : GroupDtoFromJSON(json['category']),
        'controls': json['controls'] == null ? undefined : ((json['controls'] as Array<any>).map(ControlDtoFromJSON)),
    };
}

export function CategoryWithControlsDtoToJSON(json: any): CategoryWithControlsDto {
    return CategoryWithControlsDtoToJSONTyped(json, false);
}

export function CategoryWithControlsDtoToJSONTyped(value?: CategoryWithControlsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': GroupDtoToJSON(value['category']),
        'controls': value['controls'] == null ? undefined : ((value['controls'] as Array<any>).map(ControlDtoToJSON)),
    };
}

